(() => {
  if (customElements.get('sm-gift-picker')) return;
  let adding = false;
  class GiftPicker extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.select = this.querySelector('select');
      this.add = this.querySelector('.sm-gift-add');
      this.status = this.querySelector('[data-gift-status]');
      this.options = [...this.select.options].filter(o => o.value);
      this.form.addEventListener('submit', e => this.submit(e));
      this.select.addEventListener('change', () => this.selectVariant());
      const groups = ['small', 'large'].filter(size => this.options.some(o => o.dataset.size === size));
      if (groups.length && this.options.every(o => groups.includes(o.dataset.size))) {
        this.querySelector('.sm-gift-enhanced').hidden = false;
        this.select.hidden = true;
        this.select.required = false;
        this.form.querySelector('label').hidden = true;
        const summaries = groups.map(size => {
          const opts = this.options.filter(o => o.dataset.size === size);
          const prices = [...new Set(opts.map(o => o.dataset.money))];
          return `${size === 'small' ? 'Small' : 'Large'} ${prices.length === 1 ? prices[0] : ''} · ${opts.length} colours`;
        });
        this.querySelector('summary small').textContent += ' — ' + summaries.join(' / ');
        const sizes = this.querySelector('[data-gift-sizes]');
        for (const size of groups) {
          const opts = this.options.filter(o => o.dataset.size === size);
          const prices = [...new Set(opts.map(o => o.dataset.money))];
          const b = document.createElement('button');
          b.type = 'button'; b.dataset.size = size;
          b.textContent = `${size === 'small' ? 'Small' : 'Large'} · ${prices.length === 1 ? prices[0] : 'Choose colour for price'}`;
          b.disabled = opts.every(o => o.disabled); b.setAttribute('aria-pressed', 'false');
          b.addEventListener('click', () => {
            sizes.querySelectorAll('button').forEach(x => x.setAttribute('aria-pressed', String(x === b)));
            this.select.value = ''; this.selectVariant();
            const colors = this.querySelector('[data-gift-colors]'); colors.replaceChildren();
            this.querySelector('[data-gift-description]').textContent = `${opts.length} colour${opts.length === 1 ? '' : 's'} · Choose your favourite.`;
            opts.forEach(o => {
              const c = document.createElement('button'); c.type = 'button';
              c.textContent = o.dataset.color + (o.disabled ? ' — Sold out' : '');
              c.disabled = o.disabled; c.setAttribute('aria-pressed', 'false');
              c.addEventListener('click', () => { this.select.value = o.value; this.selectVariant(); colors.querySelectorAll('button').forEach(x => x.setAttribute('aria-pressed', String(x === c))); });
              colors.append(c);
            });
          });
          sizes.append(b);
        }
      }
      this.selectVariant();
    }
    selectVariant() {
      const o = this.select.selectedOptions[0]; const valid = o?.value && !o.disabled;
      this.add.disabled = !valid;
      this.add.textContent = valid ? `Add gift box · ${o.dataset.money}` : 'Choose your gift box';
      const img = this.querySelector('[data-gift-image]'); img.hidden = !valid || !o.dataset.image;
      if (!img.hidden) { img.src = o.dataset.image; img.alt = o.dataset.color + ' gift box'; }
      this.querySelector('[data-gift-description]').textContent = valid ? o.textContent.trim() : 'Choose a size and colour.';
      this.status.textContent = '';
    }
    async submit(e) {
      e.preventDefault(); e.stopPropagation();
      if (adding || window.smCartQuantityPending || window.smCartAddPending) { this.status.textContent = 'Please wait for your bag to finish updating.'; return; }
      const option = this.select.selectedOptions[0];
      if (!option?.value || option.disabled) { this.status.textContent = 'Please choose an available size and colour.'; return; }
      adding = true; window.smCartAddPending = true;
      this.add.disabled = true; this.add.setAttribute('aria-busy', 'true'); this.status.textContent = 'Adding your gift box…';
      const isDrawer = this.dataset.context === 'cart-drawer' || this.dataset.context === 'product';
      const root = window.Shopify?.routes?.root || '/';
      const ids = [...new Set([...(isDrawer ? ['cart-drawer'] : [this.dataset.sectionId]), 'cart-icon-bubble'])].filter(Boolean);
      const controls = [...this.querySelectorAll('button, select'), ...document.querySelectorAll('.cart__checkout-button')].map(el => [el, el.disabled]);
      controls.forEach(([el]) => { el.disabled = true; });
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      let added = false;
      try {
        const response = await fetch(root + 'cart/add.js', {method:'POST', signal:controller.signal, headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({items:[{id:option.value, quantity:1}], sections:ids, sections_url:location.pathname})});
        const data = await response.json();
        if (!response.ok || data.status || data.errors) throw new Error(data.description || data.message || 'This gift box could not be added.');
        added = true;
        if (isDrawer) {
          const drawer = document.querySelector('cart-drawer');
          if (!drawer?.renderContents || !data.sections?.['cart-drawer']) { location.assign(root + 'cart'); return; }
          drawer.renderContents(data);
        } else {
          const cart = document.querySelector('cart-items-component');
          if (!cart?.updateSections || !data.sections?.[this.dataset.sectionId]) { location.assign(root + 'cart'); return; }
          cart.updateSections(data.sections);
        }
        const current = [...document.querySelectorAll('sm-gift-picker')].find(p => p.dataset.context === this.dataset.context);
        if (current) { current.querySelector('summary').focus(); current.querySelector('[data-gift-status]').textContent = 'Gift box added. You can change its quantity or remove it in your bag.'; }
      } catch (error) {
        if (added) { location.assign(root + 'cart'); return; }
        this.status.textContent = (error.name === 'AbortError' || error.message === 'Failed to fetch') ? 'Unable to confirm the addition. Check your bag before trying again.' : error.message;
      } finally {
        clearTimeout(timeout);
        controls.forEach(([el, disabled]) => { if (el.isConnected) el.disabled = disabled; });
        adding = false; window.smCartAddPending = false;
        if (this.isConnected) { this.add.disabled = !this.select.selectedOptions[0]?.value || this.select.selectedOptions[0]?.disabled; this.add.removeAttribute('aria-busy'); }
      }
    }
  }
  customElements.define('sm-gift-picker', GiftPicker);
})();
